export default () => {
  return 'https://shop-api.personalcollection.com.my'
}